import React, { useMemo } from "react"

import { useSectionViewed } from "../../../hooks/useSectionViewed"
import type { CityData } from "../../../libs/bounce/cities"
import { useUrl } from "../../../libs/router"
import { useAppURL } from "../../../utils/appURL"
import { PlaceSlider } from "../../Generic/PlaceSlider/PlaceSlider"

export type PoiSliderProps = {
  pois: CityData["pois"]
  title?: string
  subtitle?: string
  limit: number
  className?: string
}

export const PoiSlider = ({ pois, title, subtitle, limit, className }: PoiSliderProps) => {
  const { sectionRef } = useSectionViewed({ name: "PlacesSlider" })
  const { getUrl } = useUrl()
  const buildAppURL = useAppURL()

  const places = useMemo(() => {
    if (!pois) {
      return []
    }

    return pois
      .map(poi => {
        const appUrl = buildAppURL(getUrl({ path: "/s" }), { query: poi.query })

        return { ...poi, href: appUrl, url: appUrl }
      })
      .slice(0, limit)
  }, [pois, limit, getUrl, buildAppURL])

  if (!places.length) {
    return null
  }

  return (
    <PlaceSlider
      title={title}
      subtitle={subtitle}
      places={places}
      sectionRef={sectionRef}
      className={className}
      cardImageClassName="!h-[180px] md:!h-[220px]"
      cardImageContainerClassName="!h-[180px] md:!h-[220px]"
      isPlaceCardSubtitleVisible={true}
    />
  )
}
